import React from "react";
import "../styles/Header.css";

const Header = () => {
  return (
    <div className="header">
      <h2>Admin Panel</h2>
    </div>
  );
};

export default Header;
